export interface PermissionRoleActionTypes {
    type: PermissionRoleActions;
    payload?: any;
  }
  
  export enum PermissionRoleActions {
    GET_PERMISSION_ROLE_LIST = "GET_PERMISSION_ROLE_LIST",
    SET_PERMISSION_ROLE_LIST = "SET_PERMISSION_ROLE_LIST",
    SET_PERMISSION_IN_ROLE = "SET_PERMISSION_IN_ROLE",  //setting departments in sections
  }